import { createContext, useContext, useState, useEffect } from 'react';
import translations from '../translations';
import supabase from '../lib/supabase';

const LanguageContext = createContext();

export function LanguageProvider({ user, children }) {
  const [lang, setLang] = useState(localStorage.getItem('gedready-lang') || 'en');

  // Load language preference from Supabase when user logs in
  useEffect(() => {
    if (!user) return;
    supabase.from('profiles').select('language').eq('id', user.id).single()
      .then(({ data }) => {
        if (data?.language && data.language !== lang) {
          setLang(data.language);
          localStorage.setItem('gedready-lang', data.language);
        }
      });
  }, [user]);

  async function switchLang(newLang) {
    setLang(newLang);
    localStorage.setItem('gedready-lang', newLang);
    if (user) {
      await supabase.from('profiles').update({ language: newLang }).eq('id', user.id);
    }
  }

  // t() — returns translated string or calls function with args
  function t(key, ...args) {
    const val = translations[lang]?.[key] ?? translations['en']?.[key];
    if (typeof val === 'function') return val(...args);
    return val ?? key;
  }

  // tSubject() — translates a subject key (e.g. 'Math' → 'Matemáticas')
  function tSubject(key) {
    return translations[lang]?.subjects?.[key] ?? key;
  }

  // tTopic() — translates a topic key (e.g. 'Algebra' → 'Álgebra')
  function tTopic(key) {
    return translations[lang]?.topics?.[key] ?? key;
  }

  return (
    <LanguageContext.Provider value={{ lang, switchLang, t, tSubject, tTopic }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLang() {
  return useContext(LanguageContext);
}
